import { AllocationBase } from '../../accounting/abstract/allocation-base.model';

export class PurchaseInvoiceItemAllocation extends AllocationBase {

    static override CLASS_NAME: string = 'PurchaseInvoiceItemAllocation';

}
